import { Editor, IAllProps } from '@tinymce/tinymce-react';
import React from 'react';
import { Editor as TinyMCEEditor } from 'tinymce';

import './index.scss';

type WysiwygEditorProps = {
  editorInitConfig: IAllProps['init'];
  editorRef: React.MutableRefObject<TinyMCEEditor | null>;
  mainEditorConfig: IAllProps;
};

export type TinyMCEWysiwygEditor = TinyMCEEditor;

const WysiwygEditor = ({ editorInitConfig, editorRef, mainEditorConfig }: WysiwygEditorProps) => {
  const { content_style, ...editorConfig } = editorInitConfig;
  return (
    <Editor
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      licenseKey="gpl"
      onInit={(evt, editor) => {
        editorRef.current = editor;
        editorRef.current.focus();
      }}
      init={{
        directionality: 'ltr',
        table_style_by_css: true,
        link_context_toolbar: true,
        extended_valid_elements: 'table[style|class]',
        table_default_styles: {
          width: '50%',
          'border-collapse': 'collapse',
          'border-width': '1px',
          'border-color': 'black',
          'border-style': 'solid',
        },
        font_family_formats:
          'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Calibri=calibri, Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Sans Serif=sans-serif; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
        paste_data_images: true, // Allow images from Word to be pasted
        paste_webkit_styles: 'all', // Keep as many styles as possible (for WebKit-based browsers)
        paste_merge_formats: false, // Prevent merging of formats to keep the original formatting from Word
        paste_as_text: false, // Ensures that the pasted content is not plain text
        editable_class: 'editable-content',
        noneditable_class: 'noneditable-content',
        content_style: `
          p { margin: 0; }
          :focus-visible { 
            outline: none; 
          }
          ${content_style}`,
        ...editorConfig,
      }}
      {...mainEditorConfig}
    />
  );
};

export default WysiwygEditor;
